module.exports = __webpack_public_path__ + "img/movie15.482c9414.png";